const markNoShow = (state = null, action) => {
    if (action.type === "SET_NOSHOW") {
        return action.payload;
    } else {
        return state;
    }
};

export default markNoShow;
